import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
} from '@mui/material';

import { validLanguages } from '@remote-voice/utilities';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CancelButton from '@/components/atoms/CancelButton';

export type ProjectionModeDialogProps = {
  open: boolean;
  onClose: (language: string[] | undefined | null) => void;
  defaultLanguages: string[] | undefined;
};

const ProjectionModeDialog = (props: ProjectionModeDialogProps) => {
  const { t: tCommon } = useTranslation('common');
  const { t: tChat } = useTranslation('chat')
  const [selectedLanguages, setSelectedLanguages] = useState<string[] | undefined>(
    props.defaultLanguages
  );

  useEffect(() => {
    setSelectedLanguages(props.defaultLanguages);
  }, [props.defaultLanguages]);

  const handleLanguageToggle = (language: string) => {
    setSelectedLanguages((prev) => {
      const current = prev ?? [];
      if (current.includes(language)) {
        return current.filter((l) => l !== language);
      }
      if (current.length >= 2) {
        return current;
      }
      return [...current, language];
    });
  };

  return (
    <Dialog open={props.open}>
      <DialogTitle sx={{ whiteSpace: 'pre-wrap' }}>{tChat('projectionMode.dialogTitle')}</DialogTitle>
      <DialogContent dividers>
        <FormGroup>
          {validLanguages.map((language) => (
            <FormControlLabel
              key={language}
              control={
                <Checkbox
                  checked={selectedLanguages?.includes(language) ?? false}
                  onChange={() => handleLanguageToggle(language)}
                  disabled={
                    (!(selectedLanguages ?? []).includes(language) && 
                     (selectedLanguages ?? []).length >= 2)
                  }
                />
              }
              label={tCommon(`languages.${language}` as any)}
            />
          ))}
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Box
          display="flex"
          flexWrap="wrap"
          justifyContent="center"
          gap={1}
          width={1}
        >
          <CancelButton onClick={() => props.onClose(null)} />
          <Button onClick={() => props.onClose(selectedLanguages)}>
            {tCommon('command.ok')}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectionModeDialog;
